import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appStructure } from '../../../../config';
import ProfileNavItem from './ProfileNavItem';

class ProfileNav extends Component {
  render() {
    const { profile } = appStructure;
    let { subnav } = profile;

    subnav = Object.values(subnav);

    subnav = [
      ...subnav,
      {
        id: 'api',
        title: 'API key',
        path: '/profile/api',
        translated: 'account.api',
      },
    ].filter(({ id }) => {
      if (id === 'contracts') {
        return !!this.props.documents;
      }
      return true;
    });
    const mapped = subnav.map((el, i) => {
      switch (el.title) {
        case 'Profile':
          return { order: 0, value: el };
        case 'Security':
          return { order: 1, value: el };
        case 'Notifications':
          return { order: 2, value: el };
        // case 'Social Networks':
        //   return { order: 3, value: el };
        case 'Payment Data':
          return { order: 4, value: el };
        case 'Contracts':
          return { order: 5, value: el };
        case 'Password':
          return { order: 6, value: el };
        case 'API key':
          return { order: 7, value: el };
        default:
          break;
      }
    });

    mapped.sort((a, b) => {
      if (a.order > b.order) {
        return 1;
      }
      if (a.order < b.order) {
        return -1;
      }
      return 0;
    });
    const filtered = mapped.filter(el => (el ? el : false));

    subnav = filtered.map(el => el.value);

    return (
      <div className="profile-nav">
        {subnav.map(navItem => {
          return (
            <ProfileNavItem
              translated={navItem.translated}
              key={navItem.path}
              title={navItem.title}
              path={navItem.path}
            />
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = ({ webmaster }) => ({
  documents: webmaster.profile.documents,
});

export default connect(mapStateToProps)(ProfileNav);
